import React, { FC, useEffect } from 'react'
import AddPostModal from '../../components/Calendar/ModalAddPost'
import ModalPostType from '../../components/Calendar/ModalPostType'
import SchedulePostModal from '../../components/Calendar/ModalSchedulePost'
import MainHeader from '../../components/Calendar/Header'
import MainHeaderApproval from '../../components/Calendar-approval/Header'
import Navigation from '../../components/Navigation'
import EditProfileModal from '../../components/Settings/EditProfileModal'
import { useSelector } from '../../store'
import Roles from '../../models/roles'

interface MainProps { }

const Main: FC<MainProps> = ({ children }) => {

  const { user } = useSelector(({ auth: { user }}) => ({
    user
  }))

  const showMainHeader = user?.agency_role === Roles.INTERNAL_APPROVER  || user?.agency_role === Roles.EXTERNAL_APPROVER;

  return (
    <div className='approval-layout'>
      <div className='approval-layout__projects'>
        <Navigation isEnablePageNavigation={false} />
      </div>
      <div className='approval-layout__content-wrapper'>
        {showMainHeader ?
          <MainHeaderApproval /> :
          <MainHeader />
        }
        <div className='approval-layout__content'>{children}</div>
      </div>
      <AddPostModal />
      <ModalPostType />
      <EditProfileModal />
      <SchedulePostModal />
    </div>
  )
}

export default Main
